import { render, staticRenderFns } from "./NextUpgrade.vue?vue&type=template&id=13dd29e3&scoped=true&"
import script from "./NextUpgrade.vue?vue&type=script&lang=js&"
export * from "./NextUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./NextUpgrade.vue?vue&type=style&index=0&id=13dd29e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd29e3",
  null
  
)

export default component.exports